import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.edit-reconcile-session.views.SessionStatementControls`

export default defineMessages({
  statementDateLabel: {
    id: `${scope}.statementDateLabel`,
    defaultMessage: 'Statement date',
  },
  lastStatementCaption: {
    id: `${scope}.lastStatementCaption`,
    defaultMessage: 'Last statement:',
  },
  noLastStatement: {
    id: `${scope}.noLastStatement`,
    defaultMessage: '--',
  },
  statementDatePlaceholder: {
    id: `${scope}.statementDatePlaceholder`,
    defaultMessage: 'Select date',
  },
  endingBalanceLabel: {
    id: `${scope}.endingBalanceLabel`,
    defaultMessage: 'Ending balance',
  },
  endingBalanceAriaLabel: {
    id: `${scope}.endingBalanceAriaLabel`,
    defaultMessage: 'Ending balance',
  },
})
